import {NumberAbbreviation} from './abbr-number';
import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from './constants-enumerate';
import {translationConfig} from './__config/numbers-config';


const state = storeInstance.getState();

const numberAbbr = new NumberAbbreviation(state[sdoNs.SESSION.locale], translationConfig);

storeInstance.subscribe(() => {
  const state = storeInstance.getState();
  numberAbbr.lang = state[sdoNs.SESSION].locale;
});

export {
  numberAbbr
};
